import { companyService } from 'services';
import { useState } from 'react';

import { useMutation } from '@tanstack/react-query';
import { companyAdacter } from 'adapters';
import { contextApp, contextCompany } from 'context';
import { useForm } from 'react-hook-form';

const useCompany = validation => {
 const { isRTL } = contextApp();
 const [modal, setModal] = useState(false);
 const { user, setUser, step, setStep, nit, setNit } = contextCompany();
 const [dataCompany, setDatacompany] = useState({
  company: {},
  banks: {},
  social: {},
  settingAccount: {}
 });

 const {
  register,
  handleSubmit,
  formState: { errors },
  watch,
  setValue,
  reset,
  clearErrors
 } = useForm();

 const { consultCompanyByNit, registerCompany } = companyService;
 //const queryClient = useQueryClient();
 const mutateConsult = useMutation(consultCompanyByNit);
 const mutateRegister = useMutation(registerCompany);

 /* const { data, isLoading } = useQuery({
  queryKey: ['companyData'],
  queryFn: () => companyService.getCompany(auth?.token, company)
 }); */

 const onSubmitData = async data => {
  const newData = { ...user, ...data };
  setUser(newData);

  if (step === 2)
   mutateRegister.mutate(companyAdacter.register(newData), {
    onSuccess: obj => {
     console.log(obj, 'respuesta del servidor');
     setUser({ ...user, ...obj });
    }
   });

  console.log('se preciono el boton ', step, user, newData);
  setStep(step + 1);
 };

 const onError = () => {
  if (!validation) {
   clearErrors();
   setStep(step + 1);
  }
 };

 //const toggle = () => setModal(!modal);

 const handleNavs = targetStep => {
  if (step !== 3) {
   if (targetStep < step) {
    setStep(targetStep);
   } else {
    handleSubmit(onSubmitData, onError)();
   }
  } else {
   setModal(!modal);
  }
 };

 const consultCompany = nit => {
  mutateConsult.mutate(nit, {
   onSuccess: obj => {
    const data = { ...user, ...obj };
    setUser(data);
    setNit(false);
    reset(data);
    //queryClient.invalidateQueries(['routesCategory']);
   }
  });
 };

 return {
  dataCompany,
  //isLoading,
  setDatacompany,
  //data,
  register,
  handleSubmit,
  errors,
  watch,
  setValue,
  reset,
  user,
  step,
  setStep,
  isRTL,
  consultCompany,
  handleNavs,
  onError,
  onSubmitData,
  modal,
  setModal,
  nit,
  setNit
 };
};

export default useCompany;
